import { useMatchMedia } from '@library';

const useMobileViewMatchMedia = () => {
    return useMatchMedia('(max-width: 767px)');
};

export default useMobileViewMatchMedia;
